import { Fieldset as MantineFieldset } from '@mantine/core'

import type { FieldsetProps } from '@/components/Fieldset/Fieldset.types'

import classes from './Fieldset.module.css'

export function Fieldset({ legend, ...props }: FieldsetProps) {
  return (
    <MantineFieldset
      className={classes.fieldset}
      legend={legend}
      m={0}
      p={0}
      variant="unstyled"
      {...props}
    />
  )
}
